module.exports = __webpack_public_path__ + "img/jth-3.dfa6ff62.png";